import { render, staticRenderFns } from "./PostSale.vue?vue&type=template&id=fbfed5f0"
import script from "./PostSale.vue?vue&type=script&lang=js"
export * from "./PostSale.vue?vue&type=script&lang=js"
import style0 from "./PostSale.vue?vue&type=style&index=0&id=fbfed5f0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports